function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm2.4-2.7a9.6 9.6 0 004.8-2.952V10.8a2.4 2.4 0 01-2.4-2.4V3.684a9.547 9.547 0 00-3.6-1.2V3.6A2.4 2.4 0 0110.8 6v1.2a2.4 2.4 0 01-2.4 2.4V12H12a2.4 2.4 0 012.4 2.4zm-4.8 0V18a2.4 2.4 0 01-2.4-2.4v-1.2h-.6a1.8 1.8 0 01-1.8-1.8v-3H2.7a9.612 9.612 0 006.9 11.7z",
  fill: "#fff"
});

var SvgGlobe = function SvgGlobe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGlobe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/globe.5f9cea20.svg";
export { ForwardRef as ReactComponent };